<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Velocity Limit">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-between pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-template
                  (keyup)="applyFilter()"
                  [inputData]="attrConstant.search"
                  [formControlName]="
                    attrConstant.search.key
                  "></app-input-template>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
              <div class="d-flex align-items-center gap-10">
                <img
                  src="assets/images/reload.svg"
                  alt="reload"
                  class="reload-img"
                  matTooltip="Reload"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="reload()" />
                <button class="btn primary-btn" (click)="export()">
                  Export
                </button>
              </div>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let element" data-label="ID">
                  {{ element.id }}
                </td>
              </ng-container>

              <!-- Source Currency Column -->
              <ng-container matColumnDef="source_currency">
                <th mat-header-cell *matHeaderCellDef>Source Currency</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Source Currency">
                  {{ element.source_currency }}
                </td>
              </ng-container>

              <!-- Destination Currency Column -->
              <ng-container matColumnDef="destination_currency">
                <th mat-header-cell *matHeaderCellDef>Destination Currency</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Destination Currency">
                  {{ element.destination_currency }}
                </td>
              </ng-container>

              <!-- Source Country Column -->
              <ng-container matColumnDef="source_country">
                <th mat-header-cell *matHeaderCellDef>Source Country</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Source Country">
                  <img
                    height="20"
                    alt="source-country"
                    class="me-2"
                    src="assets/images/country-square/{{
                      element.source_country
                    }}.png" />
                  {{ element.source_country }}
                </td>
              </ng-container>

              <!-- Destination Country Column -->
              <ng-container matColumnDef="destination_country">
                <th mat-header-cell *matHeaderCellDef>Destination Country</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Destination Country">
                  <img
                    height="20"
                    alt="destination-country"
                    class="me-2"
                    src="assets/images/country-square/{{
                      element.destination_country
                    }}.png" />
                  {{ element.destination_country }}
                </td>
              </ng-container>

              <!-- Cash Pickup Column -->
              <ng-container matColumnDef="cash_pickup">
                <th mat-header-cell *matHeaderCellDef>Cash Pickup</th>
                <td mat-cell *matCellDef="let element" data-label="Cash Pickup">
                  {{ element.cash_pickup ?? '--' }}
                </td>
              </ng-container>

              <!-- Mobile Transfer Column -->
              <ng-container matColumnDef="mobile_transfer">
                <th mat-header-cell *matHeaderCellDef>Mobile Transfer</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Mobile Transfer">
                  {{ element.mobile_transfer ?? '--' }}
                </td>
              </ng-container>

              <!-- Bank Transfer Column -->
              <ng-container matColumnDef="bank_transfer">
                <th mat-header-cell *matHeaderCellDef>Bank Transfer</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Bank Transfer">
                  {{ element.bank_transfer ?? '--' }}
                </td>
              </ng-container>

              <!-- Wallet Column -->
              <ng-container matColumnDef="wallet">
                <th mat-header-cell *matHeaderCellDef>Wallet</th>
                <td mat-cell *matCellDef="let element" data-label="Wallet">
                  {{ element.wallet ?? '--' }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container
                    *appHasAccess="'/settings/velocity-limit/edit/:id'">
                    Action
                  </ng-container>
                </th>
                <td mat-cell *matCellDef="let element" data-label="Action">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="left"
                      [attr.aria-hidden]="true"
                      (click)="onEdit(element)"
                      *appHasAccess="'/settings/velocity-limit/edit/:id'" />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="onDeleteVelocity(element)"
                      *appHasAccess="'delete-velocity-limit'" />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="
                  let row;
                  columns: displayedColumns;
                  let element
                "></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)"></mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'/settings/velocity-limit/add'">
        <ng-template mat-tab-label>
          <a
            class="btn primary-btn"
            [routerLink]="['/settings/velocity-limit/add']">
            Add Velocity
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
